import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import requestor from "@/utils/requestor"
import api from '@/api'
import i18n from '@/locales/index'
import { Toast, Dialog } from 'vant';
import GlobalFilter from '@/utils/filter'
import VueClipboard from 'vue-clipboard2';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VerifySlider from 'vue-verify-slider'
import jsCookie from 'js-cookie'
import psl from 'psl';

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(VueClipboard)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(VerifySlider)

Vue.prototype.$cookie = jsCookie

const languageMap = {
  'zh-CN': 'zh',
  'zh-TW': 'tw',
  'en': 'en',
  'fr': 'fr',
  'de': 'de',
  'it': 'it',
  'ja': 'ja',
  'ko': 'ko',
  'pt-PT': 'pt',
  'ru': 'ru',
  'es': 'es',
  'th': 'th',
  'vi': 'vi',
  'tr': 'tr'
}

Vue.use(Vant)

Vue.use(GlobalFilter)

Vue.prototype.$EventBus = new Vue()

Vue.prototype.$Toast = Toast

Vue.prototype.$Dialog = Dialog

Vue.config.productionTip = false

Vue.prototype.$api = api

Vue.prototype.$requestor = requestor

Vue.prototype.NProgress = NProgress

Vue.prototype.I18n = i18n

Vue.prototype.$serviceBtn = process.env.VUE_APP_SERVICE_BTN

Vue.prototype.$onLaunched = new Promise(resolve => {
  Vue.prototype.$isResolve = resolve
})

Vue.prototype.setLanguage = value => {
  localStorage.setItem('language', value);
  Vue.prototype.$requestor.setLanguage(value)
  if (JSON.parse(localStorage.getItem('new_text')) && JSON.parse(localStorage.getItem('new_text'))[value]) {
    i18n.setLocaleMessage(value, Object.assign(i18n.messages[value], JSON.parse(localStorage.getItem('new_text'))[value]))
  }else{
    i18n.setLocaleMessage(value, i18n.messages[value])
  }
}

if (process.env.VUE_APP_BASE_URL != "") {
  Vue.prototype.$requestor.setBaseUrl(process.env.VUE_APP_BASE_URL)
} else {
  let parsed = psl.parse(location.host);
  Vue.prototype.$requestor.setBaseUrl('https://api.' + parsed.domain + '/api')
}

if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'en')
}
i18n.locale = localStorage.getItem('language');

api.getTextConfig().then(res => {
  if (res.code == 200) {
    localStorage.setItem('new_text', JSON.stringify(res.data))
    Vue.prototype.setLanguage(localStorage.getItem('language'))
  }
})

Vue.prototype.setToken = value => {
  Vue.prototype.$requestor.setToken(value);
  localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, value);
}
if (localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)) {
  Vue.prototype.$requestor.setToken(localStorage.getItem(process.env.VUE_APP_TOKEN_KEY))
}

Vue.prototype.$requestor.errorHandle[401] = () => {
  if (localStorage.getItem('token')) {
    localStorage.removeItem('token')
    location.reload()
  }
}

Vue.prototype._isRefresh = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    Vue.prototype._isRefresh = true
  }
})